/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext, useCallback, useRef } from 'react'
import { motion } from 'framer-motion'
import TopHeader from '../../components/TopHeader'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import InputBox from '../../CommonMethods/InputBox'
import { dataService } from '../../services/data.services'
import { userService } from '../../services/user.services'
import ErrorMessage from '../../components/ErrorMessage'
import OtpInputField from '../../components/OtpInput'
import Loader from '../../components/Loader'
import GlobalContext from '../../components/Context/GloablContext'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import { handleSystemConfig } from '../../redux/systemConfigSlice'
import { convertEpochToDateFormat } from '../../CommonMethods/convertEpochToDateFormat'
import CustomOverLay from '../../components/CustomOverLay'
import Emptyscreenwithouttitle from '../../components/Emptyscreenwithouttitle'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
import { useGetSubDivQuery } from '../../slices/apiSlice'
import MaskedEmail from '../../CommonMethods/MaskedEmail'
import formatMobileNumber from '../../CommonMethods/FormatMobileNumber';
import { handleClear, handleSidebarAnimation } from '../../redux/commonSlice'
import { organizationusersList } from '../../slices/apiSlice'
import { logout } from '../../pages/auth/authSlice';
import HelpGuideModal from '../../components/HelpGuideModal'
import { useGetHelpGuideOrganizationQuery } from '../../slices/patientSlice'
import { broadcastLogout, clearAuthData } from '../../CommonMethods/AuthSync'
import maskValue from '../../CommonMethods/maskedEmailFunction'


export default function Profile() {
    const restrictSidebar = sessionStorage.getItem('restrict')
    const otpInputRef = useRef(null);
    // const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const countryCodeList = useSelector((state) => state?.systemConfigData?.countryCodes)
    const [countryCodeVal, setCountryCodeVal] = useState('')
    const [countryCodeVal2, setCountryCodeVal2] = useState('')
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const country_code = useSelector(state => state.systemConfigData.globalVariables.country_code)
    const dispatch = useDispatch()
    const userType = sessionStorage.getItem('user_type');
    const navigate = useNavigate()
    const [queryParams, setQueryParams] = useState(``, { refetchOnMountOrArgChange: true })
    let { data, isFetching, isLoading, status } = useGetSubDivQuery(queryParams)
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar, setToastWarnmessage, restrictKey } = useContext(GlobalContext)
    const [preferences, setPreference] = useState({
        "mobile_number": "",
        "country_code": country_code && country_code.match(/\d+/)?.[0],
        "otp_preference_mode": "text",
        "email_address": ""
    })
    const [countryCodes, setCountryCodes] = useState([])
    const [otp, setOtp] = useState("000000");
    const [error, seterror] = useState(false);
    const [duration, setDuration] = useState('')
    const [timer, setTimer] = useState(parseInt(duration));
    const [loading, setloading] = useState(false);
    const [verifyOtpScreen, setVerifyOtpScreen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("")
    const [profileDetails, setProfileDetails] = useState({});
    const [deletePreferenceModal, setDeletePreferenceModal] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState({});
    const [emailError, setEmailError] = useState(false);
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [logOutOpen, setLogOutOpen] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [emptyScreen, setEmptyScreen] = useState(false);
    const [initialLoader, setInitialLoader] = useState(true);
    const [initialLoaderProfile, setInitialLoaderProfile] = useState(true);
    const restrict = useSelector(state => state?.systemConfigData?.restrict)
    const [submitSelected, setSubmitSelected] = useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({ "mobile_number": true });
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });



    const [getData, setGetData] = useState()


    const [globalVariables, setGlobalVariables] = useState({
        "date_format": "",
        "country_code": "",
        "max_file_size": "",
        "email_addr": "",
        "session_timeout": "",
        "public_encryp_key": "",
        "browser_trust_duration": "",
        "temp_pass_duration": "",
        "recent_otp_durn": "",
        "max_failed_attempts": "",
        "otp_validity_durn": ""
    })

    const fetchSystemConfigData = useCallback(async () => {
        // setLoading(true )
        let response
        response = await dataService.systemConfigDataFromAdmin();
        if (response.error === false) {
            setGetData(response.data.data)
            dispatch(handleSystemConfig(response.data))
            const Getdata = response.data.data
            setGlobalVariables((prev) => ({
                ...prev,
                "date_format": Getdata?.global_variables?.date_format,
                "country_code": Getdata?.global_variables?.country_code,
                "max_file_size": Getdata?.global_variables?.maximum_file_size,
                "email_addr": Getdata?.global_variables?.email_address,
                "session_timeout": Getdata?.global_variables?.session_timeout,
                "public_encryp_key": Getdata?.global_variables?.public_encryption_key,
                "browser_trust_duration": Getdata?.global_variables?.browser_trust_duration,
                "temp_pass_duration": Getdata?.global_variables?.temporary_password_expiry_duration,
                "recent_otp_durn": Getdata?.global_variables?.resend_otp_duration,
                "max_failed_attempts": Getdata?.global_variables?.max_failed_login_attempts,
                "otp_validity_durn": Getdata?.global_variables?.otp_validity_duration
            }))
        }

    }, [])

    useEffect(() => {
        fetchSystemConfigData()
    }, [])

    useEffect(() => {
        setCountryCodeVal(`${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`)
    }, [country_code])



    const [preferenceList, setPreferenceList] = useState([]);
    const [hoverProperties, setHoverProperties] = useState({
        'hover': '',
        'hover_index': '',
        'index_to_display_modal': ''
    })

    const handleOtpPreference = (val) => {
        setEmailError(false)
        setPhoneNumberError(false)
        // Check if email_address is not empty, if not, set it to an empty string
        const updatedEmail = preferences.email_address !== "" ? "" : preferences.email_address;

        // Check if mobile_number is not empty, if not, set it to an empty string
        const updatedMobileNumber = preferences.mobile_number !== "" ? "" : preferences.mobile_number;

        setPreference({
            ...preferences,
            "otp_preference_mode": val,
            "email_address": updatedEmail,
            "mobile_number": updatedMobileNumber
        });
    };

    const fetchCountryCodes = async () => {
        const res = await dataService?.getCountryCodes();
        // const extractedValues = res.data.map((country) => country.callingCodes[0]+'\t'+'-'+'\t'+'('+country.name+')');
        let uniqueValues = [...new Set(res?.data?.map((country) => country.callingCodes[0] + '\t' + '-' + '\t' + '(' + country.alpha3Code + ')'))];
        setCountryCodes(uniqueValues)
    }

    useEffect(() => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+ ${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`
        }));
        fetchCountryCodes()
    }, [])

    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-profile');
        } else {
            setQueryParamsorg('type=org-user-profile');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    const handleUserInput = (id, value) => {
        setSubmitSelected(false)
        setEmailError(false)
        setPhoneNumberError(false)
        const isMobileNumber = id === "mobile_number";
        const sanitizedOption = isMobileNumber ? value.replace(/\D/g, "") : value;
        const isValid = isMobileNumber ? /^[1-9]\d*$/.test(sanitizedOption) : true;
        setPreference((prev) => ({
            ...prev,
            [id]: isValid ? value : sanitizedOption
        }));
        if (!isValid) {
            setEmailError(false);
        }
    };




    const handleCountryCode = (val) => {
        setPreference({
            ...preferences,
            "country_code": val
        })
    }
    const handleVerification = async () => {
        setVerificationLoading(true)
        setSubmitSelected(true)
        if (preferences.otp_preference_mode === 'email' && validateEmail(preferences?.email_address.trim())) {
            setEmailError(true);
            setVerificationLoading(false)
            return
        }
        if ((preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') && !(isPhoneNumberValid.mobile_number)) {
            setVerificationLoading(false)
            return;
        }
        const body =
        {
            "country_code": preferences.otp_preference_mode === 'email' ? '' : (countryCodeVal === '' ? `+ ${country_code}` : `+ ${countryCodeVal}`),
            "preference": preferences.email_address === '' ? preferences.mobile_number : preferences.email_address.trim(),
            "otp_preference_mode": preferences.otp_preference_mode,
            "restrict": true,
        }
        const response = await userService.verifyPreference(body)
        if (response.error === false) {
            setVerifyOtpScreen(true)
            setVerificationLoading(false)
        } else if (response.error === true) {
            setToastErrorMessage(response.message?.response?.data?.message || 'Something went wrong')
            setVerificationLoading(false)
        } else {
            setVerificationLoading(false)
            setToastErrorMessage('Something went wrong')
        }

    }

    const handleFetchPreferenceList = async () => {
        const response = await userService.preferenceList();
        if (response.error === false && response.data.data.length > 0) {
            setPreferenceList(response.data.data)
            setInitialLoader(false)
            setEmptyScreen(false)
        } else {
            setInitialLoader(false)
            setEmptyScreen(true)
        }
    }

    useEffect(() => {
        setOtp(Array(6).fill(""))
        handleFetchPreferenceList()
        handleFetchProfileDetails()
    }, [])


    const handleOTPVerification = async (e) => {
        e.preventDefault();
        setloading(true)
        const val = otp.toString().replace(/,/g, '')
        const body = {
            otp: val
        }
        const response = await userService.verifyOtp(body)
        if (response.error === false) {
            setToastmessage(response.data.message)
            handleFetchPreferenceList()
            setloading(false)
            setPreference({
                "mobile_number": "",
                "country_code": "",
                "otp_preference_mode": "text",
                "email_address": ""
            });
            setVerifyOtpScreen(false)
            setOtp(Array(6).fill(""))
        } else {
            setloading(false)
            setVerifyOtpScreen(true)
            if (response.message.response.data.message === "Invalid OTP entered 3 times, your preferences couldn't be saved. Please re-enter your preferences") {
                setToastWarnmessage(response.message.response.data.message)
                setOtp(Array(6).fill(""))
                setPreference({
                    "mobile_number": "",
                    "country_code": "",
                    "otp_preference_mode": "text",
                    "email_address": ""
                });
                setVerifyOtpScreen(false)

            } else {
                setOtp(Array(6).fill(""))
                seterror(true)
                setErrorMsg(response.message.response.data.message)
                // setToastErrorMessage(response.message.response.data.message)
            }
        }
    };


    const handleFetchProfileDetails = async () => {
        setInitialLoaderProfile(true)
        const response = await dataService.getOrganizationUserdetails(sessionStorage.getItem('id'));
        if (response.error === false) {
            sessionStorage.setItem('org_id', response.data.data[0].organization_id)
            setProfileDetails(response.data.data[0])
            setInitialLoaderProfile(false)
        } else {
            setInitialLoaderProfile(false)
        }
    }

    const openDeleteModal = (item) => {
        if (profileDetails?.enforce_otp_verification === true && preferenceList.length === 1) {
            setToastErrorMessage('Atleast one preference is required')
        }
        else {
            setSelectedPreference(item)
            setDeletePreferenceModal(true)
        }

    }

    const handleDeletePreferences = async () => {
        setDeleteLoading(true)
        const response = await userService.deletePreference(selectedPreference._id);
        if (response.error === false) {
            setDeleteLoading(false)
            setDeletePreferenceModal(false)
            handleFetchPreferenceList()
            setToastmessage('Mode of preference deleted successfully')
        } else {
            setDeleteLoading(false)
            setDeletePreferenceModal(false)
            handleFetchPreferenceList()
            setToastErrorMessage('Error while deleting mode of preference')
        }
    }
    const handleSelectCountryCode = (item) => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+ ${parseInt(item.match(/\d+/)?.[0], 10)}`
        }));
        setCountryCodeVal(`+ ${parseInt(item.match(/\d+/)?.[0], 10)}`)
    }


    const handleLogout = async () => {
        setLogoutLoading(true)
        const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
        const logout = await userService.logout()
        if (logout.error === false) {
            // Step 1: Set logout flags
            localStorage.setItem('localLogoutAt', Date.now().toString());
            localStorage.setItem('localLogoutInProgress', 'true');
            
            // Step 2: CRITICAL - Clear toast flag BEFORE broadcasting
            localStorage.removeItem('showLogoutToast');
            
            // Step 3: Clear auth data from both sessionStorage and localStorage
            clearAuthData()
            
            // Step 4: Broadcast logout event to all tabs
            broadcastLogout()
            
            // Step 5: Reset Redux state
            dispatch(organizationusersList.util.resetApiState())
            
            // Step 6: Show success toast
            setToastmessage('Logout successful')
            
            // Step 7: Navigate to login page
            navigate('/')
            setLogoutLoading(false)
        } else {
            setLogOutOpen(false)
            setLogoutLoading(false)
            setToastErrorMessage('Something went wrong!')
        }
    }
    // const handleLogout=async ()=>{
    //     setLogoutLoading(true)
    //     const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
    //     dispatch(handleClear())
    //     await userService.logout()
    //     dispatch(logout());
    //     dispatch(organizationusersList.util.resetApiState())
    //     localStorage.setItem('arcm_trust_browser_token', browserIdValue);
    //     dispatch(handleSidebarAnimation(true))
    //     setToastmessage('Logout successful')  
    //     navigate('/')
    //     setLogoutLoading(false)  
    // }


    const handleCancel = () => {
        setVerifyOtpScreen(false)
        setPreference({
            "mobile_number": "",
            "country_code": country_code && country_code.match(/\d+/)?.[0],
            "otp_preference_mode": "text",
            "email_address": ""
        });
        handleFetchPreferenceList()
        setOtp(Array(6).fill(""))
    }

    useEffect(() => {
        if (otpInputRef.current) {
            otpInputRef.current.focus();
        }
    }, [otp]);


    return (
        <>

            <TopHeader title={"Profile"} />
            {verifyOtpScreen ?
                <>
                    <div className='flex flex-col justify-center items-center h-screen m-auto'>
                        <div className='w-full'>
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>OTP Verification</h1>
                            <h1 className='text-lg font-normal text-[#777C88] text-center mb-[55px]'>
                                Enter the 6-digit OTP sent to {preferences.otp_preference_mode === 'email'
                                    ? maskValue(preferences.email_address)
                                    : `${countryCodeVal === ''
                                        ? `+${country_code} ${preferences.mobile_number?.slice(0, 2) +
                                        '*'.repeat(preferences?.mobile_number?.length - 4) +
                                        preferences?.mobile_number?.slice(-2)}`
                                        : `+${countryCodeVal} ${preferences.mobile_number?.slice(0, 2) +
                                        '*'.repeat(preferences?.mobile_number?.length - 4) +
                                        preferences?.mobile_number?.slice(-2)}`
                                    }`
                                }
                            </h1>
                            <form onSubmit={(e) => handleOTPVerification(e)}>
                                <div className="digit-group flex justify-center pt-1.5">
                                    <OtpInputField
                                        onChange={setOtp}
                                        inputs={otp}
                                        setInputs={setOtp}
                                        value={otp}
                                        inputType="tel"
                                        shouldAutoFocus
                                        inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                        numInputs={6}
                                        error={error}
                                        seterror={seterror}
                                        renderInput={(props) => <input {...props} />}
                                        separator={<span></span>}
                                        ref={otpInputRef}
                                    />
                                </div>
                                {/* errormessage */}
                                {error && <ErrorMessage error={error} message={errorMsg} classKey="text-xs font-normal text-[#C81720] mt-5 text-center" />}

                                <div className='flex justify-center'>
                                    <button type='submit'
                                        id="otp-form"
                                        disabled={otp.includes("") || loading || errorMsg === "Invalid session for the user."}
                                        className='w-[290px] mt-8 py-2 px-4 text-lg font-semibold text-[#fff] rounded-[16px] 
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                        {!loading ? ' Verify OTP' : <span>{<Loader />}</span>}
                                    </button>
                                </div>
                                <div className='flex justify-center'>
                                    <button
                                        disabled={loading}
                                        className='w-[290px] px-4 py-2 border border-[#972E4C] h-fit rounded-[16px]  pl-2.5 text-center text-lg font-normal text-[#972E4C] m-auto mt-[30px]'
                                        onClick={() => handleCancel()}
                                    >I didn't receive the OTP</button></div>
                            </form>
                        </div>
                    </div>
                </>
                :
                <>
                    {initialLoaderProfile ? <CustomOverLay Active text="Loading Profile details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> :
                        (<div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full scrollbar_purple overflow-x-hidden'>
                            <div className='bg-white rounded-lg py-[16px] px-[30px]'>
                                <div className='flex justify-between items-center'>
                                    <div className='flex items-center'>
                                        <h1 className='text-xl font-normal text-[#000000]'>My Profile</h1>
                                        <span onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                        </span>

                                    </div>
                                    <div className='flex items-center'>
                                        <Link to='/profile/update-password'>
                                            <button className='min-w-max px-2.5 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center  text-lg font-normal text-[#972E4C] mr-2'>Update Password</button>
                                        </Link>
                                        {(restrict) &&
                                            <button onClick={() => setLogOutOpen(true)} className='min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center pl-2.5 text-lg font-normal text-[#972E4C]'>Logout</button>}
                                    </div>
                                </div>
                                <div className="">
                                    <div className="overflow-auto scrollbar_purple pr-2.5">
                                        <div className="mt-3 w-full border border-[#C5C9DA] rounded-sm px-6 pt-[22px] pb-[22px]">
                                            <div className="flex items-center">
                                                <p className="text-xl font-semibold text-[#000000]">{profileDetails?.organization_name === '' ? '-' : profileDetails?.organization_name}</p>
                                                <p className="text-sm font-normal text-[#000000] pl-3.5">{profileDetails?.organization_id === '' ? '-' : profileDetails?.organization_id}</p>
                                                <div className='ml-3.5'>
                                                    {profileDetails?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                                        (<p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>)
                                                    }
                                                </div>
                                            </div>
                                            <div className="rounded-sm mt-[20px] pb-[22px]">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="xl:w-1/5 w-1/3 px-1 mb-[30px]">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">{profileDetails?.user_name === '' ? '-' : profileDetails?.user_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-2/3 px-1 mb-[30px]">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">{profileDetails?.email_address === '' ? '-' : profileDetails?.email_address}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-1/3 px-1 mb-[30px]">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">   {profileDetails?.mobile_number ? (
                                                                <>
                                                                    {profileDetails?.mobile_country_code}{" "}
                                                                    {formatMobileNumber(profileDetails?.mobile_number)}
                                                                </>
                                                            ) : (
                                                                "-"
                                                            )}</p>

                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {profileDetails?.main_number ? (
                                                                    <>
                                                                        {profileDetails?.main_country_code}{" "}
                                                                        {formatMobileNumber(profileDetails?.main_number)}
                                                                    </>
                                                                ) : (
                                                                    "-"
                                                                )}</p>

                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">{profileDetails?.created_at === '' ? '-' : convertEpochToDateFormat(profileDetails?.created_at, dateformat)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Enforce OTP</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">{profileDetails?.enforce_otp_verification ? 'True' : 'False'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/5 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">{profileDetails?.organization_address === '' ? '-' : profileDetails?.organization_address}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* subdivision list */}
                                <div>

                                    <div>
                                        <div class='border border-[#EDD7E1] mt-4 mb-4 mr-2 rounded pb-2'>
                                            <div class='relative flex border-b border-[#EDD7E1] justify-between items-center'>
                                                <p class='text-base w-full py-5 font-semibold pl-[17px] text-[#972E4C]'>Sub Division List</p>
                                            </div>
                                            {((status !== "fulfilled" && status !== "rejected") || (data === undefined && status !== "fulfilled" && status !== "rejected")) ?
                                                <CustomOverLay Active text="Loading Sub Division List..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_overlay2' : 'overlay-list2'}`} /> : <>
                                                    <table id="organization_table" aria-label="Outside Table" class="w-full table-fixed">
                                                        <thead>
                                                            <tr class="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                                <th class="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">ID</span>
                                                                </th>
                                                                <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Sub Division Name</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {data?.data.map((subdivision, index) => (
                                                                <tr key={index}>
                                                                    <td class="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{subdivision.subdivision_id}</td>
                                                                    <td class="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{subdivision.subdivision_name}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                </>
                                            }
                                        </div>
                                    </div>

                                </div>

                                <div className="">
                                    <div className="pr-2.5">
                                        <div className="mt-5 w-full border border-[#C5C9DA] rounded-sm px-6 pt-[22px] pb-[12px]">
                                            <div className="flex items-center">
                                                <p className="text-xl font-normal text-[#000000]">Add OTP Preference</p>
                                            </div>
                                            <div className='w-full flex tm:flex-nowrap flex-wrap'>
                                                <div className='items-center flex mb-[15px] justify-center'>
                                                    <div className='rounded-[16px] border flex border-[#C5C9DA]  py-1 items-center'>
                                                        <p
                                                            onClick={() => !verificationLoading && handleOtpPreference("text")}
                                                            id='text'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'text' ? 'text-[#972E4C]' : 'text-[#777C88]'}  text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'text' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                            Text
                                                        </p>
                                                        <p
                                                            onClick={() => !verificationLoading && handleOtpPreference("voice")}
                                                            id='voice'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'voice' ? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'voice' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                            Voice
                                                        </p>
                                                        <p
                                                            onClick={() => !verificationLoading && handleOtpPreference("email")}
                                                            id='email'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'email' ? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'email' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                            Email
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='tn:w-1/3  xl:pl-[41px] pl-[20px] '>
                                                    <div className={`w-full mb-[35px]`}>
                                                        <PhoneNumberValidator
                                                            label={"Telephone Number *"}
                                                            placeholder={"Enter Telephone Number"}
                                                            id={"mobile_number"}
                                                            data_testid={"mobile_number"}
                                                            htmlFor={"mobile_number"}
                                                            value={preferences.mobile_number}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleUserInput}
                                                            isCode={true}
                                                            countryCodeList={countryCodes}
                                                            handleCountryCode={handleCountryCode}
                                                            handleSelectCountryCode={handleSelectCountryCode}
                                                            countryCodeVal={countryCodeVal}
                                                            disabled={(preferences.otp_preference_mode === 'email') ? true : false}
                                                            maxLength={30}
                                                            preferences={preferences}
                                                            setCountryCodeVal={setCountryCodeVal}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            isPhoneNumberValid={isPhoneNumberValid.mobile_number}

                                                        />
                                                    </div>
                                                    {phoneNumberError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]  '} message={"Invalid telephone number"} />}
                                                </div>

                                                <div className={`tn:w-1/3 tn:pr-0 pr-[20px]   xl:px-[41px] ${isSideBar ? ' pl-[20px]' : ""} tn:pl-[20px]`}>
                                                    <div className={`w-full ${emailError ? 'mb-[15px]' : 'mb-[35px]'}`}>
                                                        <InputBox
                                                            label={"Email Address *"}
                                                            placeholder={"Enter Email Address"}
                                                            id={"email_address"}
                                                            data_testid={"email_address"}
                                                            htmlFor={"email_address"}
                                                            value={preferences.email_address}
                                                            handleOnChangeInput={handleUserInput}
                                                            disabled={(preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') ? true : false}
                                                            emailError={emailError}
                                                        />
                                                    </div>
                                                    {emailError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]'} message={"Invalid email address"} />}
                                                </div>

                                                <div className={`mb-[15px] flex`}>
                                                    <div className="flex items-center">
                                                        <button
                                                            className=" tm:w-[250px] w-[210px] bg-[#972E4C] text-white py-2.5 rounded-[16px] text-lg font-normal mr-[16px] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]"
                                                            id='verification_btn'
                                                            disabled={(preferences.mobile_number === '' && preferences.email_address === '') || verificationLoading || !isPhoneNumberValid}
                                                            onClick={() => handleVerification()}
                                                        >{verificationLoading ? <Loader /> : 'Save Preference'}
                                                        </button>
                                                    </div>

                                                    <button
                                                        className='w-[150px] px-4 py-2 border border-[#972E4C] rounded-[16px] hidden  pl-2.5 text-lg font-normal text-[#972E4C]'
                                                    >
                                                        Cancel
                                                    </button>
                                                    <img src='/images/cancel-circle.svg' alt='icon' className="cursor-pointer ml-5 hidden" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center my-[20px]">
                                    <p className="text-xl font-normal text-[#000000]">OTP Preference List</p>
                                </div>
                                {emptyScreen ? <Emptyscreenwithouttitle FirstPTag={"No OTP preferences added yet"} /> :
                                    (
                                        <div className="overflow-auto scrollBar-hidden mt-3.5">
                                            <table aria-label="Outside Table" className="w-full table-auto">
                                                <thead>
                                                    <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                        <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                                            </span>
                                                        </th>
                                                        <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                                            </span>
                                                        </th>
                                                        <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">OTP Preference Mode
                                                            </span>
                                                        </th>
                                                        <th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] max-w-[245px] sticky right-0 pl-[92px]">
                                                            <span className="flex items-center justify-center text-end text-sm font-normal text-[#000000]">Action
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {preferenceList.map((item, index) => (
                                                        <tr key={index} className={`${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'} hover:bg-[#F8EEF1] h-[45px] table-tr`}>
                                                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item.otp_preference_mode === 'email' ? item.preference : '-'}</td>
                                                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{(item.otp_preference_mode === 'text' || item.otp_preference_mode === 'voice') ? item.country_code + ' ' + formatMobileNumber(item.preference) : '-'}</td>
                                                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item.otp_preference_mode === 'email' ? "Email" : item.otp_preference_mode === 'text' ? "Text" : "Voice"}</td>
                                                            <td className={`px-8 py-2 text-sm text-end font-normal sticky right-0 max-w-[245px] text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px] last-td ${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'}`}>
                                                                <div className="flex justify-center ">
                                                                    <div onMouseEnter={() => { setHoverProperties((prev) => ({ ...prev, hover: 'modify', hover_index: index })) }}
                                                                        onMouseLeave={() => { setHoverProperties((prev) => ({ ...prev, hover: '', hover_index: null })) }} className="px-8  min-w-[200px]">
                                                                        {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index)) || (hoverProperties.index_to_display_modal === index && confirmation)) ? <>
                                                                            <motion.div
                                                                                initial={{ opacity: 1, x: 0, y: 0 }}
                                                                                animate={{ opacity: 1, x: -45, y: 0 }}
                                                                                transition={{ delay: 0.2, duration: 0.5 }}
                                                                                exit={{ opacity: 0.5 }}
                                                                                className=''
                                                                            >
                                                                                <button

                                                                                >
                                                                                    <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                                            </motion.div>
                                                                        </> : <button

                                                                            id={index + 'edit'}
                                                                        >
                                                                            <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                                                        {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index)) || (hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                                            <motion.div
                                                                                initial={{ opacity: 0, x: 0, y: 0 }}
                                                                                animate={{ opacity: 1, x: 0, y: 0 }}
                                                                                transition={{ delay: 0.2, duration: 0.5 }}
                                                                                exit={{ opacity: 0.5 }}
                                                                                className=''
                                                                            >
                                                                                <div className='relative ml-5 cursor-pointer mt-[-25px]' onClick={() => { openDeleteModal(item) }} >
                                                                                    <p id='remove' className="text-sm ml-10  font-normal text-[#972E4C] ">Remove</p>
                                                                                </div>
                                                                            </motion.div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                            </div>
                        </div>)
                    }
                </>
            }
            {deletePreferenceModal &&
                <AnimatedModel key="logout-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleDeletePreferences}
                            handleClose={() => { setDeletePreferenceModal(false), setSelectedPreference({}) }}
                            tittle={`Delete`}
                            message={
                                (preferenceList.length === 1 && profileDetails?.enforce_otp_verification === true)
                                    ? 'This is your only preference. If you delete it, you would need to replace it with a new one. Are you sure you want to delete this mode of preference?'
                                    : (preferenceList.length === 1 && profileDetails?.enforce_otp_verification === false)
                                        ? 'This is your only preference. If you delete it, you would be turning off OTP verification.Are you sure you want to delete this mode of preference?'
                                        : 'Are you sure you want to delete this mode of preference?'
                            } buttonName={`Delete`}
                            loadingActivation={deleteLoading}
                            disabled={deleteLoading}
                        />
                    }
                />
            }
            {logOutOpen &&
                <AnimatedModel key="logout-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleLogout}
                            handleClose={() => setLogOutOpen(false)}
                            tittle={`Logout`}
                            message={`Are you sure you want to logout?`}
                            buttonName={`Logout`}
                            disabled={logoutLoading}
                            loadingActivation={logoutLoading}
                            data_testid={'logout-btn'}
                        />
                    }
                />
            }
            {(helpGuideModel && helpguidestatus === "fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </>
    )
}
